export default {
    state: {
        cardRechargeMenu: {
            isVisible: false
        },
        payMethodModal: {
            isVisible: false,
            text: '',
            icon: '',
            buttons: [],
            paymentMethods: [
                {
                    name: 'Cartão de crédito',
                    id: 1,
                    show: false
                },
                {
                    name: 'Pix',
                    id: 2,
                    show: false
                },
                {
                    name: 'Boleto',
                    id: 3,
                    show: false
                }
            ],
            types: {
                default: {
                    icon: 'fa-regular fa-credit-card',
                    buttons: [
                        {
                            buttonText: 'Confirmar',
                            buttonAction: ''
                        }
                    ]
                }
            }
        },
        rechargePaymentInfra: {
            flags: [
                'Visa',
                'Mastercard',
                'Amex',
                'Diners',
                'Elo',
                'Alelo',
                'Sodexo',
                'Hipercard',
                'Aura'
            ],
            inputs: [
                {
                    display: 'Numero do cartão',
                    placeHolder: 'Nº do cartão',
                    type: 'text',
                    required: true,
                    format: 'cardNumber'
                },
                {
                    display: 'Nome do titular',
                    placeHolder: 'Nome do titular',
                    type: 'text',
                    required: true
                },
                {
                    display: 'Data de Validade',
                    placeHolder: 'Validade',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cardDate'
                },
                {
                    display: 'Cód. de Segurança',
                    placeHolder: 'CVV',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cardCVV'
                }
            ]
        },
        cardCVVMenu: {
            isVisible: false
        }
    },
    mutations: {
        setCardRechargeMenuVisibility (state) {
            state.cardRechargeMenu.isVisible =
                !state.cardRechargeMenu.isVisible
        },
        showPayMethodModal (state, data) {
            const type = data.type || 'default'
            state.payMethodModal.text = data.text
            state.payMethodModal.icon = state.payMethodModal.types[type].icon
            state.payMethodModal.buttons =
                data.buttons || state.payMethodModal.types[type].buttons
            state.payMethodModal.isVisible = true
        },
        closePayMethodModal (state) {
            state.payMethodModal.isVisible = false
        },
        setCardCVVMenuVisibility (state) {
            state.cardCVVMenu.isVisible = !state.cardCVVMenu.isVisible
        },
        setPaymentMethodsVisibility (state, data) {
            state.payMethodModal.paymentMethods[0].show =
                data?.ENABLED_PAYMENTS?.includes('C')
            state.payMethodModal.paymentMethods[1].show =
                data?.ENABLED_PAYMENTS?.includes('P')
            state.payMethodModal.paymentMethods[2].show =
                data?.ENABLED_PAYMENTS?.includes('B')
        }
    },
    actions: {
        changeCardRechargeMenuVisibility ({ commit }) {
            commit('setCardRechargeMenuVisibility')
        },
        showPayMethodModal ({ commit }, data) {
            commit('showPayMethodModal', data)
        },
        closePayMethodModal ({ commit }) {
            commit('closePayMethodModal')
        },
        changeCardCVVMenuVisibility ({ commit }) {
            commit('setCardCVVMenuVisibility')
        },
        setPaymentMethodsVisibility ({ commit }, data) {
            commit('setPaymentMethodsVisibility', data)
        }
    },
    getters: {
        cardRechargeMenu: (state) => state.cardRechargeMenu,
        payMethodModal: (state) => state.payMethodModal,
        rechargePaymentInfra: (state) => state.rechargePaymentInfra,
        cardCVVMenu: (state) => state.cardCVVMenu
    }
}
